import {TStore} from 'models';

export const selectUser = (state: TStore) => state?.user?.data;
